import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuxDataAccountsTableColumnDirective } from '../auxiliary-data-accounts-table-column.directive';

const EPOC_DATE = '2008-01-01';

@Component({
  template: `
    <uikit-async-ui class="last-activity" [data]="lastUpdateDate" [loading]="loading$ | async">
      <ng-container *successData="let data">
        <ng-container *ngIf="data !== 'never'; else emptyValue">
          {{ data | date : 'shortDate' }}
        </ng-container>
        <ng-template #emptyValue>
          {{ 'COMMON.DATES.NEVER' | translate }}
        </ng-template>
      </ng-container>
      <ng-container loading>
        <div class="light-shimmer account-activity-loading"></div>
      </ng-container>
    </uikit-async-ui>
  `,
  styles: ['.account-activity-loading { height: 20px; margin: 8px;}'],
})
export class LastUpdateDateColumnComponent extends AuxDataAccountsTableColumnDirective implements OnInit {
  loading$: Observable<boolean>;
  lastUpdateDate: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (this.element.lastUpdateDate > new Date(EPOC_DATE)) {
      this.lastUpdateDate = this.element.lastUpdateDate.toDateString();
    } else {
      this.lastUpdateDate = 'never';
    }
  }
}
